import React from 'react';
import { PlayCircle, Award, Trophy, CheckCircle2 } from 'lucide-react';
import { marketplaceFeatures } from '../mock';

export default function About() {
  return (
    <section id="services" className="bg-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <nav className="text-xs text-slate-500 mb-6">
          <a href="#" className="hover:text-orange-600">Home</a> <span className="mx-1.5">/</span> <span className="text-slate-700">CA Services</span>
        </nav>

        <h2 className="text-2xl md:text-3xl font-extrabold text-[#0b3d5b] leading-snug">
          Online Top Chartered Accountants In India / Chartered Accountant Near Me / CA Online Services
        </h2>
        <p className="mt-4 text-slate-600 leading-relaxed">
          <span className="font-semibold text-[#0b3d5b]">Register Point</span> is an online directory where you can access the best online CA services with the help of top chartered accountants in India. We bring verified tax consultants together at one place. From tax filing to company registration, GST to trademark — get every business compliance solved by a certified professional near you.
        </p>

        {/* Video Card */}
        <a
          href="https://www.youtube.com"
          target="_blank"
          rel="noreferrer"
          className="mt-8 rounded-2xl overflow-hidden border border-slate-200 bg-slate-900 relative aspect-video max-w-3xl flex items-center justify-center text-white text-lg font-semibold hover:opacity-90 transition-opacity"
        >
          Visit our YouTube channel
        </a>

        {/* Looking online */}
        <div className="mt-14 grid md:grid-cols-5 gap-8 items-start">
          <div className="md:col-span-2">
            <div className="aspect-square rounded-2xl bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-100 p-8 flex items-center justify-center">
              <div className="text-center">
                <div className="w-24 h-24 mx-auto rounded-full bg-white shadow-lg flex items-center justify-center">
                  <PlayCircle className="w-12 h-12 text-orange-500" />
                </div>
                <div className="mt-4 text-[#0b3d5b] font-bold text-lg">Verified CA Network</div>
                <div className="text-sm text-slate-600 mt-1">Serving 500+ cities across India</div>
              </div>
            </div>
          </div>
          <div className="md:col-span-3">
            <h3 className="text-xl md:text-2xl font-bold text-[#0b3d5b]">Looking Online for CA Service / CA Near Me?</h3>
            <p className="mt-3 text-slate-600 leading-relaxed">
              With more than a decade of experience in business and tax advisory, Register Point offers verified professionals — Chartered Accountants, Company Secretaries and tax consultants in India — who assure the fastest possible delivery and excellent quality on every service assigned to them.
            </p>
            <p className="mt-3 text-slate-600 leading-relaxed">
              Our clients&apos; needs are constantly changing with the digital era, and so we continually work to be on the best path to serve them. We&apos;re building an online service marketplace where every service seeker can find CA services near their locality, or choose from the list of top chartered accountants in India based on specialization and reviews.
            </p>
          </div>
        </div>

        {/* Founder */}
        <div className="mt-14 rounded-2xl bg-gradient-to-r from-[#f4f9fd] to-[#fff4ec] border border-slate-100 p-6 md:p-10 grid md:grid-cols-3 gap-6 items-center">
          <div className="md:col-span-1 flex justify-center">
            <div className="w-40 h-40 rounded-full bg-white shadow-lg border-4 border-white overflow-hidden">
              <div className="w-full h-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-white text-5xl font-bold">KM</div>
            </div>
          </div>
          <div className="md:col-span-2">
            <h4 className="text-xl font-bold text-[#0b3d5b]"></h4>
            <p className="mt-2 text-slate-600 leading-relaxed">
              A visionary business consultant, passionate about providing affordable and hassle-free CA services to everyone. As Founder &amp; CEO of Register Point, he has helped 10,000+ companies with tax planning, GST, company formation and compliance across India.
            </p>
            <div className="flex flex-wrap gap-3 mt-4">
              <span className="inline-flex items-center gap-1.5 bg-white border border-slate-200 px-3 py-1.5 rounded-full text-xs text-slate-700"><Award className="w-4 h-4 text-orange-500" /> Silicon India Cover</span>
              <span className="inline-flex items-center gap-1.5 bg-white border border-slate-200 px-3 py-1.5 rounded-full text-xs text-slate-700"><Trophy className="w-4 h-4 text-orange-500" /> Startup of the Year 2017</span>
              <span className="inline-flex items-center gap-1.5 bg-white border border-slate-200 px-3 py-1.5 rounded-full text-xs text-slate-700"><Trophy className="w-4 h-4 text-orange-500" /> Entrepreneur Award 2020</span>
            </div>
          </div>
        </div>

        {/* Marketplace features list */}
        <div className="mt-14">
          <h3 className="text-xl md:text-2xl font-bold text-[#0b3d5b]">
            We are providing an online service marketplace which can be used as an online directory where service seekers can find:
          </h3>
          <ul className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {marketplaceFeatures.map((f) => (
              <li key={f} className="flex items-start gap-2 bg-slate-50 border border-slate-100 rounded-lg px-3.5 py-3 hover:bg-orange-50 hover:border-orange-200 transition-colors">
                <CheckCircle2 className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-slate-700 font-medium">{f}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-12">
          <h3 className="text-xl md:text-2xl font-bold text-[#0b3d5b]">Consulting an Income Tax Consultant in India</h3>
          <p className="mt-3 text-slate-600 leading-relaxed">
            As our tagline says &mdash; <em>helping e-commerce grow</em> &mdash; we have helped many e-commerce businesses in India re-form and restructure. Register Point invests time and resources into every engagement to deliver best practices, current law knowledge and executable strategy. We were recognised as a leading digital financial service provider by the India Excellence Awards, and we&apos;re associated with mentors who guide us to face challenges and deliver exceptional service. Clients also get a curated list of CAs where they can search and book appointments with the best chartered accountant in India, from the best CA firms in India.
          </p>
        </div>
      </div>
    </section>
  );
}
